// extracted by mini-css-extract-plugin
module.exports = {"facetMenu":"FT","fixed":"GT","nonLayerdFacets":"HT","productCount":"IT","facetBack":"JT","arrow":"KT"};